// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"019d8017","2563":"019d8017","4525":"019d8017","4826":"6855d7ea","4849":"01e1173f","5976":"01e1173f"}[chunkId] + ".chunk.css";
};